import { useState } from 'react';
import axiosInstance from './axiosInstance'; // Import the configured Axios instance

const useApi = (apiFunction) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = async (...params) => {
    setLoading(true);
    setError(null);

    try {
      const result = await apiFunction(...params);
      setLoading(false);
      return result;
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.message || 'An unexpected error occurred');
      throw err;
    }
  };

  return { execute, loading, error };
};

export default useApi;
